(() => {
  const getNode = () => document.querySelector('[data-floating-card]');

  const mount = () => {
    const node = getNode();
    if (!node) return null;
    return node;
  };

  const api = {
    show(variant = 'default') {
      const node = mount();
      if (!node) return;

      if (node.hidden) node.hidden = false;
      node.dataset.floatingCardVariant = variant;
      node.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => node.classList.add('is-visible'));
    },
    hide() {
      const node = mount();
      if (!node) return;

      node.classList.remove('is-visible');
      node.setAttribute('aria-hidden', 'true');
    },
    update(payload = {}) {
      const node = mount();
      if (!node) return;

      if (payload.title) {
        const title = node.querySelector('[data-floating-card-title]');
        if (title) title.textContent = payload.title;
      }

      if (payload.body) {
        const body = node.querySelector('[data-floating-card-body]');
        if (body) body.textContent = payload.body;
      }

      if (payload.link) {
        const link = node.querySelector('[data-floating-card-link]');
        if (link) link.href = payload.link;
      }
    },
    mount,
  };

  window.FizoFloatingCard = api;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => api.mount(), {once: true});
  } else {
    api.mount();
  }
})();
